// El dashboard de Finanzas gestiona las facturas, cuentas por cobrar y por pagar.
import { useState, useEffect } from 'react';
import { 
    collection, addDoc, query, where, getDocs, doc, updateDoc, onSnapshot, Timestamp, arrayRemove,
    orderBy, deleteField, arrayUnion, or 
} from 'firebase/firestore';
import { 
    ref, uploadBytesResumable, getDownloadURL 
} from 'firebase/storage';
import 'react-toastify/dist/ReactToastify.css';
import { db, storage } from '../firebase/config'
import { PROYECTOS_COLLECTION} from '../utils/constants'
import { parseInvoiceXML} from '../utils/helpers'
import { Alert } from '../components/UI/Alert'
import { ConfirmationModal } from '../components/UI/ConfirmationModal';
import { toast } from 'react-toastify';


export const FinanzasDashboard = () => {
    const [view, setView] = useState('dashboard');
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPendingProjects = () => {
        setLoading(true);
        const q = query(
            collection(db, PROYECTOS_COLLECTION),
            or(
                where("necesitaFactura", "==", true),
                where("estado", "==", "Pendiente de Factura")
            )
        );
        
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const projectsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setProjects(projectsData);
            setLoading(false);
        }, (error) => {
            console.error("Error al cargar proyectos pendientes de facturación:", error);
            setLoading(false);
        });
        
        return unsubscribe;
    };
    
    useEffect(() => {
        let unsubscribe = () => {};
        if (view === 'pendientes') {
            unsubscribe = fetchPendingProjects();
        } else {
            setLoading(false);
        }
        return () => unsubscribe();
    }, [view]);
    
    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Panel de Finanzas</h1>
            <div className="mb-6 border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    <button onClick={() => setView('dashboard')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'dashboard' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Dashboard
                    </button>
                    <button onClick={() => setView('pendientes')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'pendientes' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Pendientes de Gestión
                    </button>
                    <button onClick={() => setView('cobrar')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'cobrar' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Cuentas por Cobrar
                    </button>
                    <button onClick={() => setView('pagar')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'pagar' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Cuentas por Pagar
                    </button>
                </nav>
            </div>

            {/*{view === 'dashboard' && (
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 my-6">Análisis Financiero</h2>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        <AgingReport />
                    </div>
                </div>
            )}
            */}

            {view === 'pendientes' && (
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 my-6">Proyectos Pendientes de Facturar</h2>
                    {loading ? <p>Cargando proyectos...</p> : 
                        <PendingInvoicesTable projects={projects} onUpdate={fetchPendingProjects} />
                    }
                </div>
            )}
            {view === 'cobrar' && <InvoicesList invoiceType="cliente" onUpdate={() => {}} />}
            {view === 'pagar' && <InvoicesList invoiceType="proveedor" onUpdate={() => {}} />}
        </div>
    );
};

// modal para subir facturas a proyectos pendientes de facturar
const PendingInvoicesTable = () => {
    const [pendingProjects, setPendingProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [modalProject, setModalProject] = useState(null);

    //modal para subir la facturas
    const AttachInvoicesModal = ({ project, onClose, onFinalized }) => {
        const [mode, setMode] = useState('upload');
        const [clientXmlFile, setClientXmlFile] = useState(null);
        const [providerXmlFile, setProviderXmlFile] = useState(null);
        const [clientInvoiceData, setClientInvoiceData] = useState(null);
        const [providerInvoiceData, setProviderInvoiceData] = useState(null);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState('');
        
        const [linkableInvoices, setLinkableInvoices] = useState([]);
        const [selectedClientInvoiceId, setSelectedClientInvoiceId] = useState('');
        const [selectedProviderInvoiceId, setSelectedProviderInvoiceId] = useState('');

        const isInternalProvider = project.proveedorNombre?.toLowerCase().includes("ecologia");

        useEffect(() => {
            if (mode === 'link') {
                const q = query(collection(db, "facturas"), orderBy("fechaEmision", "desc"));
                const unsubscribe = onSnapshot(q, (snapshot) => {
                    setLinkableInvoices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                });
                return () => unsubscribe();
            }
        }, [mode]);

        const handleFileChange = (e, type) => {
            const file = e.target.files[0];
            if (!file) return;

            if (type === 'client') setClientXmlFile(file);
            if (type === 'provider') setProviderXmlFile(file);

            const reader = new FileReader();
            reader.onload = (event) => {
                const xmlText = event.target.result;
                const extractedData = parseInvoiceXML(xmlText);

                if (extractedData) {
                    if (type === 'client') setClientInvoiceData(extractedData);
                    if (type === 'provider') setProviderInvoiceData(extractedData);
                    setError('');
                } else {
                    setError('Error al leer el XML. Asegúrate de que es un archivo CFDI válido.');
                }
            };
            reader.readAsText(file);
        };

        const uploadFile = async (file, path) => {
            if (!file) return null;
            const storageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(storageRef, file);
            return getDownloadURL((await uploadTask).ref);
        };

        const handleSave = async () => {
            setLoading(true);
            setError('');
            try {
                const projectRef = doc(db, PROYECTOS_COLLECTION, project.id);
                const updatePayload = {};
                const hasClientInvoice = 
                    (project.facturasClienteIds && project.facturasClienteIds.length > 0) || 
                    (mode === 'upload' && clientXmlFile && clientInvoiceData) ||
                    (mode === 'link' && selectedClientInvoiceId);

                const hasProviderInvoice = 
                    isInternalProvider ||
                    (project.facturasProveedorIds && project.facturasProveedorIds.length > 0) ||
                    (mode === 'upload' && providerXmlFile && providerInvoiceData) ||
                    (mode === 'link' && selectedProviderInvoiceId);

                if (hasClientInvoice && hasProviderInvoice) {
                    updatePayload.necesitaFactura = false;

                    if (project.estado === 'Pendiente de Factura') {
                        updatePayload.estado = 'Terminado';
                        updatePayload.estadoCliente = 'Terminado';
                    }
                } else {
                    updatePayload.necesitaFactura = true;
                }

                if (mode === 'upload') {
                    if (clientXmlFile && clientInvoiceData) {
                        const urlXml = await uploadFile(clientXmlFile, `facturas_clientes/${project.id}/${clientXmlFile.name}`);

                        const fechaClienteSegura = new Date(clientInvoiceData.fechaEmision);
                        fechaClienteSegura.setHours(12, 0, 0, 0); 

                        const newInvoiceRef = await addDoc(collection(db, "facturas"), {
                            tipo: "cliente",
                            proyectoId: project.id,
                            folio: clientInvoiceData.folio,
                            uuid: clientInvoiceData.uuid,
                            subtotal: clientInvoiceData.subtotal,
                            iva: clientInvoiceData.iva,
                            monto: clientInvoiceData.monto,
                            fechaEmision: Timestamp.fromDate(fechaClienteSegura),
                            estado: "Pendiente",
                            urlXml: urlXml,
                            pdfUrl: '',
                            clienteNombre: project.clienteNombre,
                        });
                        updatePayload.facturasClienteIds = arrayUnion(newInvoiceRef.id);
                    }

                    if (!isInternalProvider && providerXmlFile && providerInvoiceData) {
                        const urlXml = await uploadFile(providerXmlFile, `facturas_proveedores/${project.id}/${providerXmlFile.name}`);
                        
                        const fechaProvSegura = new Date(providerInvoiceData.fechaEmision);
                        fechaProvSegura.setHours(12, 0, 0, 0);

                        const newInvoiceRef = await addDoc(collection(db, "facturas"), {
                            tipo: "proveedor",
                            proyectoId: project.id,
                            folio: providerInvoiceData.folio,
                            uuid: providerInvoiceData.uuid,
                            subtotal: providerInvoiceData.subtotal,
                            iva: providerInvoiceData.iva,
                            monto: providerInvoiceData.monto,
                            fechaEmision: Timestamp.fromDate(fechaProvSegura),
                            estado: "Pendiente",
                            urlXml: urlXml,
                            proveedorNombre: project.proveedorNombre,
                        });
                        updatePayload.facturasProveedorIds = arrayUnion(newInvoiceRef.id);
                    }
                } else {
                    if (selectedClientInvoiceId) {
                        await updateDoc(doc(db, "facturas", selectedClientInvoiceId), { proyectosIds: arrayUnion(project.id) });
                        updatePayload.facturasClienteIds = arrayUnion(selectedClientInvoiceId);
                    }
                    if (selectedProviderInvoiceId && !isInternalProvider) {
                        await updateDoc(doc(db, "facturas", selectedProviderInvoiceId), { proyectosIds: arrayUnion(project.id) });
                        updatePayload.facturasProveedorIds = arrayUnion(selectedProviderInvoiceId);
                    }
                }

                if (Object.keys(updatePayload).length > 0) {
                    await updateDoc(projectRef, updatePayload);
                }
                
                onFinalized();
                onClose();
            } catch (err) {
                setError("Ocurrió un error al guardar las facturas.");
                console.error("Error saving invoices:", err);
                setLoading(false);
            }
        };

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl">
                    <h3 className="text-lg font-bold mb-4">Gestionar Facturas: {project.npu}</h3>
                    
                    <div className="mb-4 border-b border-gray-200">
                        <nav className="-mb-px flex space-x-8">
                            <button onClick={() => setMode('upload')} className={`py-2 px-1 border-b-2 font-medium text-sm ${mode === 'upload' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                                Subir Nueva Factura (XML)
                            </button>
                            <button onClick={() => setMode('link')} className={`py-2 px-1 border-b-2 font-medium text-sm ${mode === 'link' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                                Enlazar Factura Existente
                            </button>
                        </nav>
                    </div>

                    {mode === 'upload' && (
                        <div className={`grid grid-cols-1 ${!isInternalProvider ? 'md:grid-cols-2' : ''} gap-6`}>
                            <div className="space-y-4 p-4 border rounded-lg">
                                <h4 className="font-semibold text-gray-800">Factura a Cliente</h4>
                                {project.facturasClienteIds?.length > 0 ? <p className="text-green-600 font-semibold">✓ Factura ya adjuntada.</p> : (
                                    <>
                                        <label className="block text-sm font-medium">Subir archivo XML</label>
                                        <input type="file" name="clientXml" accept=".xml" onChange={(e) => handleFileChange(e, 'client')} className="block w-full text-sm"/>
                                        {clientInvoiceData && (
                                            <div className="text-xs bg-gray-50 p-2 rounded-md mt-2 space-y-1">
                                                <p><strong>Folio:</strong> {clientInvoiceData.folio}</p>
                                                <p><strong>Subtotal:</strong> ${clientInvoiceData.subtotal?.toFixed(2)}</p>
                                                <p><strong>IVA:</strong> ${clientInvoiceData.iva?.toFixed(2)}</p>
                                                <p><strong>Total:</strong> ${clientInvoiceData.monto?.toFixed(2)}</p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            {!isInternalProvider && (
                                <div className="space-y-4 p-4 border rounded-lg">
                                    <h4 className="font-semibold text-gray-800">Factura de Proveedor</h4>
                                    {project.facturasProveedorIds?.length > 0 ? <p className="text-green-600 font-semibold">✓ Factura ya adjuntada.</p> : (
                                        <>
                                            <label className="block text-sm font-medium">Subir archivo XML</label>
                                            <input type="file" name="providerXml" accept=".xml" onChange={(e) => handleFileChange(e, 'provider')} className="block w-full text-sm"/>
                                            {providerInvoiceData && (
                                                <div className="text-xs bg-gray-50 p-2 rounded-md mt-2 space-y-1">
                                                    <p><strong>Folio:</strong> {providerInvoiceData.folio}</p>
                                                    <p><strong>Subtotal:</strong> ${providerInvoiceData.subtotal?.toFixed(2)}</p>
                                                    <p><strong>IVA:</strong> ${providerInvoiceData.iva?.toFixed(2)}</p>
                                                    <p><strong>Total:</strong> ${providerInvoiceData.monto?.toFixed(2)}</p>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {mode === 'link' && (
                        <div className={`grid grid-cols-1 ${!isInternalProvider ? 'md:grid-cols-2' : ''} gap-6`}>
                            <div className="space-y-2 p-4 border rounded-lg">
                                <h4 className="font-semibold text-gray-800">Enlazar Factura de Cliente</h4>
                                <select value={selectedClientInvoiceId} onChange={(e) => setSelectedClientInvoiceId(e.target.value)} className="block w-full border rounded-md p-2">
                                    <option value="">Seleccione una factura...</option>
                                    {linkableInvoices.filter(inv => inv.tipo === 'cliente').map(inv => (
                                        <option key={inv.id} value={inv.id}>{`Folio: ${inv.folio} - $${inv.monto?.toFixed(2)}`}</option>
                                    ))}
                                </select>
                            </div>
                            {!isInternalProvider && (
                                <div className="space-y-2 p-4 border rounded-lg">
                                    <h4 className="font-semibold text-gray-800">Enlazar Factura de Proveedor</h4>
                                    <select value={selectedProviderInvoiceId} onChange={(e) => setSelectedProviderInvoiceId(e.target.value)} className="block w-full border rounded-md p-2">
                                        <option value="">Seleccione una factura...</option>
                                        {linkableInvoices.filter(inv => inv.tipo === 'proveedor').map(inv => (
                                            <option key={inv.id} value={inv.id}>{`Folio: ${inv.folio} - $${inv.monto?.toFixed(2)}`}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                    )}

                    <Alert message={error} type="error" onClose={() => setError('')} />
                    <div className="mt-6 flex justify-end space-x-3">
                        <button onClick={onClose} className="bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded">Cancelar</button>
                        <button onClick={handleSave} className="bg-[#b0ef26] text-black font-bold py-2 px-4 rounded" disabled={loading}>{loading ? 'Guardando...' : 'Guardar Cambios'}</button>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        setLoading(true);
        const q = query(
            collection(db, PROYECTOS_COLLECTION),
            or(
                where("necesitaFactura", "==", true),
                where("estado", "==", "Pendiente de Factura")
            )
        );
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setPendingProjects(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        }, (error) => {
            console.error("Error cargando facturas pendientes:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const filteredProjects = pendingProjects.filter(p => 
        (p.npu && p.npu.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (p.clienteNombre && p.clienteNombre.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (p.poClienteRef && p.poClienteRef.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredProjects.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <div className="mb-4 flex flex-col md:flex-row justify-between items-center">
                <input type="text" placeholder="Buscar por NPU, cliente o servicio..." className="w-full md:w-1/3 px-3 py-2 border border-gray-300 rounded-md mb-2 md:mb-0" onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}/>
                <div className="flex items-center">
                    <span className="text-sm mr-2">Mostrar:</span>
                    <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="px-2 py-1 border border-gray-300 rounded-md">
                        <option value={10}>10</option><option value={25}>25</option><option value={50}>50</option>
                    </select>
                </div>
            </div>
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">NPU</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Servicio</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Referencias</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Montos</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Facturas</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {loading ? (
                            <tr><td colSpan="6" className="text-center py-4">Cargando proyectos pendientes...</td></tr>
                        ) : currentItems.length === 0 ? (
                            <tr><td colSpan="6" className="text-center py-4">No hay proyectos pendientes de facturar.</td></tr>
                        ) : (
                            currentItems.map(project => (
                                <tr key={project.id}>
                                    <td className="px-6 py-4 font-medium">{project.npu}</td>
                                    <td className="px-4 py-2">{project.clienteNombre}</td>
                                    <td>
                                        <div>
                                            <p className="px-4 py-2 text-m">{project.servicioNombre}</p>
                                            <p className="px-4 py-2 text-xs text-gray-700"> {project.comentariosApertura || 'N/A'}</p>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2 text-xs text-gray-700">
                                        <div className="space-y-1">
                                            <p><span className="font-bold text-gray-600">NE:</span> {project.fase1_numeroNotaInterna || 'N/A'}</p>
                                            <p className="border-t mt-1 pt-1"><span className="font-bold text-blue-600">Cliente:</span> {project.poClienteRef || 'N/A'}</p>
                                            <p><span className="font-bold text-gray-500">Prov:</span> {project.poProveedor || 'N/A'}</p>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2 text-sm">
                                        <div className="flex flex-col">
                                            <span className="text-green-600 font-semibold">${project.precioCotizacionCliente?.toFixed(2)}</span>
                                            <span className="text-red-500 text-xs">${project.costoProveedor?.toFixed(2)}</span>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2 text-sm">
                                        <div className="flex flex-col">
                                            <div className="px-6 py-4">{project.facturasClienteIds?.length > 0 ? <span className="text-green-600">Adjunta</span> : <span className="text-orange-500">Pendiente</span>}</div>
                                            <div className="px-6 py-4">{project.proveedorNombre?.toLowerCase().includes("ecologia") ? <span className="text-gray-500">N/A</span> : project.facturasProveedorIds?.length > 0 ? <span className="text-green-600">Adjunta</span> : <span className="text-orange-500">Pendiente</span>}</div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2">
                                        <button onClick={() => setModalProject(project)} className="text-indigo-600 hover:text-indigo-900 font-bold">
                                            Adjuntar Factura
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="mt-4 flex justify-between items-center">
                <span className="text-sm text-gray-700">Página {currentPage} de {totalPages}</span>
                <div>
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white mr-2 disabled:opacity-50">Anterior</button>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} className="px-3 py-1 border rounded-md bg-white disabled:opacity-50">Siguiente</button>
                </div>
            </div>
            {modalProject && (
                <AttachInvoicesModal 
                    project={modalProject} 
                    onClose={() => setModalProject(null)} 
                    onFinalized={() => setModalProject(null)} 
                />
            )}
        </>
    );
};

// modal para subir facturas generales, y ligarlas o no a proyectos existentes
const InvoicesList = ({ invoiceType, onUpdate }) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);
    const [modalInvoice, setModalInvoice] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [confirmingAction, setConfirmingAction] = useState(null);

    useEffect(() => {
        setLoading(true);
        const q = query(collection(db, "facturas"), where("tipo", "==", invoiceType), orderBy("fechaEmision", "desc"));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            setInvoices(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        return () => unsubscribe();
    }, [invoiceType]);

    const filteredInvoices = invoices.filter(invoice => 
        (invoice.folio && String(invoice.folio).toLowerCase().includes(searchTerm.toLowerCase())) ||
        (invoice.clienteNombre && invoice.clienteNombre.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (invoice.proveedorNombre && invoice.proveedorNombre.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (invoice.descripcion && invoice.descripcion.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredInvoices.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const AddGeneralInvoiceModal = ({ onClose, onFinalized }) => {
        const [formData, setFormData] = useState({ folio: '', monto: '', fechaEmision: new Date().toISOString().split('T')[0], entidadId: '', descripcion: '' });
        const [xmlFile, setXmlFile] = useState(null);
        const [invoiceData, setInvoiceData] = useState(null);
        const [entities, setEntities] = useState([]);
        const [otherEntityName, setOtherEntityName] = useState('');
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState('');

        useEffect(() => {
            let q;
            if (invoiceType === 'cliente') {
                q = query(collection(db, "usuarios"), where("rol", "==", "cliente"));
            } else {
                q = query(collection(db, "proveedores"));
            }
            getDocs(q).then(snapshot => {
                const entityList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const sortedEntities = entityList.sort((a, b) => (a.nombreCompleto || a.nombre).localeCompare(b.nombreCompleto || b.nombre));
                setEntities(sortedEntities);
            });
        }, []);

        useEffect(() => {
            if (invoiceData) {
                setFormData(prev => ({
                    ...prev,
                    folio: invoiceData.folio,
                    subtotal: invoiceData.subtotal,
                    iva: invoiceData.iva,                    
                    monto: invoiceData.monto,
                    fechaEmision: invoiceData.fechaEmision.toISOString().split('T')[0]
                }));
            }
        }, [invoiceData]);        

        const handleFileChange = (e) => {
            const file = e.target.files[0];
            if (!file) return;

            setXmlFile(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const xmlText = event.target.result;
                const extractedData = parseInvoiceXML(xmlText);

                if (extractedData) {
                    setInvoiceData(extractedData);
                    setError('');
                } else {
                    setError('Error al leer el XML. Asegúrate de que es un archivo CFDI válido.');
                }
            };
            reader.readAsText(file);
        };

        const uploadFile = async (file, path) => {
            if (!file) return null;
            const storageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(storageRef, file);
            return getDownloadURL((await uploadTask).ref);
        };

        const handleSave = async () => {
            if (!invoiceData || !xmlFile || (formData.entidadId === '' || (formData.entidadId === 'otro' && !otherEntityName))) {
                setError("Debes subir un XML válido y seleccionar un cliente/proveedor.");
                return;
            }
            setLoading(true);
            try {
                const urlXml = await uploadFile(xmlFile, `facturas_${invoiceType}/${Date.now()}/${xmlFile.name}`);
                const entityName = formData.entidadId === 'otro' ? otherEntityName : entities.find(e => e.id === formData.entidadId)?.nombreCompleto || entities.find(e => e.id === formData.entidadId)?.nombre;

                await addDoc(collection(db, "facturas"), {
                    tipo: invoiceType,
                    proyectoId: "general",
                    folio: formData.folio,
                    uuid: invoiceData.uuid,
                    subtotal: Number(formData.subtotal),
                    iva: Number(formData.iva),
                    monto: Number(formData.monto),
                    fechaEmision: Timestamp.fromDate(new Date(formData.fechaEmision)),
                    estado: "Pendiente",
                    descripcion: formData.descripcion || '',
                    urlXml: urlXml,
                    urlPdf: '',
                    [invoiceType === 'cliente' ? 'clienteNombre' : 'proveedorNombre']: entityName
                });
                onFinalized();
                onClose();
            } catch (err) {
                console.error("Error al guardar factura general:", err);
                setError("Ocurrió un error al guardar.");
                setLoading(false);
            }
        };

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                    <h3 className="text-lg font-bold mb-4">Añadir Factura General ({invoiceType})</h3>
                    <div className="space-y-4">
                        <label className="block text-sm font-medium">Subir archivo XML (la información se cargará automáticamente)</label>
                        <input type="file" name="xmlFile" accept=".xml" onChange={handleFileChange} className="block w-full text-sm"/>
                        
                        <hr/>
                        
                        <select value={formData.entidadId} onChange={(e) => setFormData(prev => ({...prev, entidadId: e.target.value}))} name="entidadId" className="block w-full border rounded-md p-2">
                            <option value="">Seleccione un {invoiceType}</option>
                            {entities.map(e => <option key={e.id} value={e.id}>{e.nombreCompleto || e.nombre}</option>)}
                            <option value="otro">Otro (especificar)</option>
                        </select>
                        {formData.entidadId === 'otro' && (
                            <input type="text" value={otherEntityName} onChange={(e) => setOtherEntityName(e.target.value)} placeholder={`Nombre del ${invoiceType}`} className="block w-full border rounded-md p-2"/>
                        )}
                        <input type="text" name="descripcion" placeholder="Descripción (ej: Renta de oficina)" value={formData.descripcion} onChange={(e) => setFormData(prev => ({...prev, descripcion: e.target.value}))} className="block w-full border rounded-md p-2"/>
                        
                        <input type="text" name="folio" placeholder="Folio (del XML)" value={formData.folio} disabled className="block w-full border rounded-md p-2 bg-gray-100"/>
                        <input type="number" name="subtotal" placeholder="Subtotal (del XML)" value={formData.subtotal || ''} disabled className="block w-full border rounded-md p-2 bg-gray-100"/>
                        <input type="number" name="iva" placeholder="IVA (del XML)" value={formData.iva || ''} disabled className="block w-full border rounded-md p-2 bg-gray-100"/>
                        <input type="number" name="monto" placeholder="Monto (del XML)" value={formData.monto} disabled className="block w-full border rounded-md p-2 bg-gray-100"/>
                        <input type="date" name="fechaEmision" value={formData.fechaEmision} disabled className="block w-full border rounded-md p-2 bg-gray-100"/>
                    </div>
                     <Alert message={error} type="error" onClose={() => setError('')} />
                    <div className="mt-6 flex justify-end space-x-3">
                        <button onClick={onClose}>Cancelar</button>
                        <button onClick={handleSave} disabled={loading} className="bg-[#b0ef26] text-black font-bold py-2 px-4 rounded">{loading ? 'Guardando...' : 'Guardar Factura'}</button>
                    </div>
                </div>
            </div>
        );
    };

    const ManageInvoiceModal = ({ invoice, onClose, onFinalized }) => {
        const [formData, setFormData] = useState({
            fechaPromesaPago: invoice.fechaPromesaPago ? invoice.fechaPromesaPago.toDate().toISOString().split('T')[0] : '',
            fechaPagoReal: invoice.fechaPagoReal ? invoice.fechaPagoReal.toDate().toISOString().split('T')[0] : ''
        });
        const [loading, setLoading] = useState(false);

        const handleSave = async () => {
            setLoading(true);
            const updatePayload = {
                fechaPromesaPago: formData.fechaPromesaPago ? Timestamp.fromDate(new Date(formData.fechaPromesaPago)) : deleteField(),
                fechaPagoReal: formData.fechaPagoReal ? Timestamp.fromDate(new Date(formData.fechaPagoReal)) : deleteField(),
            };
            if (formData.fechaPagoReal) {
                updatePayload.estado = "Pagada";
            } else if (invoice.estado === "Pagada") {
                updatePayload.estado = "Pendiente";
            }
            await updateDoc(doc(db, "facturas", invoice.id), updatePayload);
            onFinalized();
            onClose();
        };

        const handleRequestCancel = () => {
            setConfirmingAction({
                title: "Confirmar Cancelación",
                message: `¿Estás seguro de que deseas cancelar la factura ${invoice.folio}? Esta acción es irreversible.`,
                confirmText: "Sí, Cancelar Factura",
                confirmColor: "bg-red-600",
                onConfirm: executeCancellation
            });
        };

        const executeCancellation = async () => {
            setLoading(true);
            try {
                const projectsToUpdate = invoice.proyectosIds || (invoice.proyectoId ? [invoice.proyectoId] : []);

                await updateDoc(doc(db, "facturas", invoice.id), { 
                    estado: "Cancelada",
                    proyectosIds: deleteField(),
                    proyectoId: deleteField() 
                });

                if (projectsToUpdate.length > 0) {
                    const targetArrayField = invoice.tipo === 'cliente' ? 'facturasClienteIds' : 'facturasProveedorIds';

                    await Promise.all(projectsToUpdate.map(async (pid) => {
                        if (pid === 'general') return;

                        const projectRef = doc(db, PROYECTOS_COLLECTION, pid);
                        await updateDoc(projectRef, {
                            [targetArrayField]: arrayRemove(invoice.id),
                            necesitaFactura: true
                        });
                    }));
                }

                toast.success("Factura cancelada correctamente.");
                if (onFinalized) onFinalized();
                onClose();

            } catch (error) {
                console.error("Error cancelando:", error);
                toast.error("Error al cancelar la factura.");
            } finally {
                setLoading(false);
                setConfirmingAction(null);
            }
        };
        
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                    <h3 className="text-lg font-bold mb-4">Gestionar Factura: {invoice.folio}</h3>
                    <div className="space-y-4">
                        <div><label className="block text-sm font-medium">Fecha Promesa de Pago</label><input type="date" value={formData.fechaPromesaPago} onChange={e => setFormData({...formData, fechaPromesaPago: e.target.value})} className="mt-1 block w-full border rounded-md p-2"/></div>
                        <div><label className="block text-sm font-medium">Fecha de Pago Real</label><input type="date" value={formData.fechaPagoReal} onChange={e => setFormData({...formData, fechaPagoReal: e.target.value})} className="mt-1 block w-full border rounded-md p-2"/></div>
                    </div>
                    <div className="mt-6 flex justify-between items-center">
                        <button onClick={handleRequestCancel} disabled={loading} className="bg-red-600 text-white font-bold py-2 px-4 rounded disabled:bg-red-300">Cancelar Factura</button>
                        <div>
                            <button onClick={onClose} disabled={loading} className="bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded mr-2">Cerrar</button>
                            <button onClick={handleSave} disabled={loading} className="bg-[#b0ef26] text-black font-bold py-2 px-4 rounded">{loading ? 'Guardando...' : 'Guardar'}</button>
                        </div>
                    </div>
                </div>
                {confirmingAction && (
                    <ConfirmationModal 
                        {...confirmingAction} 
                        onCancel={() => setConfirmingAction(null)} 
                    />
                )}
            </div>
        );
    };

    const formatDate = (timestamp) => !timestamp ? '---' : new Date(timestamp.seconds * 1000).toLocaleDateString('es-MX');
    
    const getStatusInfo = (invoice) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (invoice.estado === 'Pagada') {
            return { text: 'Pagada', class: 'bg-green-100 text-green-800' };
        }
        if (invoice.estado === 'Cancelada') {
            return { text: 'Cancelada', class: 'bg-gray-100 text-gray-700' };
        }
        if (invoice.fechaPromesaPago?.toDate) {
            const promiseDate = invoice.fechaPromesaPago.toDate();
            promiseDate.setHours(0, 0, 0, 0);
            if (promiseDate < today) {
                return { text: 'Vencida', class: 'bg-red-100 text-red-800' };
            } else {
                return { text: 'Prog. a Pago', class: 'bg-blue-100 text-blue-800' };
            }
        }
        return { text: 'Pend. de Autorización', class: 'bg-yellow-100 text-yellow-800' };
    };

    return (
        <div>
            <div className="mb-4 flex flex-col md:flex-row justify-between items-center">
                <input 
                    type="text"
                    placeholder="Buscar por folio, cliente/prov. o descripción..."
                    className="w-full md:w-1/3 px-3 py-2 border border-gray-300 rounded-md mb-2 md:mb-0"
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                />
                <div className="flex items-center">
                    <span className="text-sm mr-2">Mostrar:</span>
                    <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="px-2 py-1 border border-gray-300 rounded-md">
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <button onClick={() => setShowAddModal(true)} className="ml-4 bg-[#b0ef26] hover:bg-[#9ac91e] text-black font-bold py-2 px-4 rounded-lg">
                        + Añadir Factura General
                    </button>
                </div>
            </div>
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Folio</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">{invoiceType === 'cliente' ? 'Cliente' : 'Proveedor'}</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Descripción</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Subtotal</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">IVA</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Total</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Fecha Emisión</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Fecha Promesa Pago</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Fecha Pago</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Estado</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {loading ? <tr><td colSpan="11">Cargando...</td></tr> : currentItems.map(invoice => {
                            const statusInfo = getStatusInfo(invoice);
                            return (
                                <tr key={invoice.id}>
                                <td className="px-6 py-4">{invoice.folio}</td>
                                <td className="px-6 py-4">{invoice.clienteNombre || invoice.proveedorNombre}</td>
                                <td className="px-6 py-4">{invoice.descripcion || (invoice.proyectoId !== 'general' ? 'Gasto de Proyecto' : '---')}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">${(invoice.subtotal || 0).toFixed(2)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">${(invoice.iva || 0).toFixed(2)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-semibold">${(invoice.monto || 0).toFixed(2)}</td>
                                <td className="px-6 py-4">{formatDate(invoice.fechaEmision)}</td>
                                <td className="px-6 py-4">{formatDate(invoice.fechaPromesaPago)}</td>
                                <td className="px-6 py-4">{formatDate(invoice.fechaPagoReal)}</td>
                                <td className="px-6 py-4">
                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${statusInfo.class}`}>
                                        {statusInfo.text}
                                    </span>
                                </td>
                                <td className="px-6 py-4"><button onClick={() => setModalInvoice(invoice)} className="text-indigo-600">Gestionar</button></td>
                            </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="mt-4 flex justify-between items-center">
                <span className="text-sm text-gray-700">Página {currentPage} de {totalPages}</span>
                <div>
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white mr-2 disabled:opacity-50">Anterior</button>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} className="px-3 py-1 border rounded-md bg-white disabled:opacity-50">Siguiente</button>
                </div>
            </div>
            {showAddModal && <AddGeneralInvoiceModal onClose={() => setShowAddModal(false)} onFinalized={onUpdate} />}
            {modalInvoice && <ManageInvoiceModal invoice={modalInvoice} onClose={() => setModalInvoice(null)} onFinalized={onUpdate} />}
        </div>
    );
};

// eslint-disable-next-line no-lone-blocks
{/*
// modal para obtener datos de antiguedad de saldos y graficar
const AgingReport = () => {
    const [loading, setLoading] = useState(true);
    const [reportData, setReportData] = useState(null);

    useEffect(() => {
        const calculateAgingReport = async () => {
            setLoading(true);
            const q = query(
                collection(db, "facturas"),
                where("tipo", "==", "cliente"),
                where("estado", "==", "Pendiente")
            );

            const snapshot = await getDocs(q);
            const pendingInvoices = snapshot.docs.map(doc => doc.data());

            const today = new Date();
            const buckets = {
                "0-30 Días": 0,
                "31-60 Días": 0,
                "61-90 Días": 0,
                "+90 Días": 0,
            };

            pendingInvoices.forEach(inv => {
                const issueDate = inv.fechaEmision.toDate();
                const diffTime = Math.abs(today - issueDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays <= 30) buckets["0-30 Días"] += inv.monto;
                else if (diffDays <= 60) buckets["31-60 Días"] += inv.monto;
                else if (diffDays <= 90) buckets["61-90 Días"] += inv.monto;
                else buckets["+90 Días"] += inv.monto;
            });
            
            setReportData({
                labels: Object.keys(buckets),
                datasets: [{
                    label: 'Monto Pendiente de Cobro',
                    data: Object.values(buckets),
                    backgroundColor: [
                        'rgba(75, 192, 192, 0.6)',
                        'rgba(255, 206, 86, 0.6)',
                        'rgba(255, 159, 64, 0.6)',
                        'rgba(255, 99, 132, 0.6)',
                    ],
                    borderColor: [
                        'rgba(75, 192, 192, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(255, 159, 64, 1)',
                        'rgba(255, 99, 132, 1)',
                    ],
                    borderWidth: 1
                }]
            });
            setLoading(false);
        };

        calculateAgingReport();
    }, []);

    if (loading) return <p>Calculando reporte de antigüedad...</p>;

    const options = {
        indexAxis: 'y',
        responsive: true,
        plugins: {
            legend: { display: false },
            title: {
                display: true,
                text: 'Monto Pendiente de Cobro por Antigüedad'
            }
        }
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow-md">
            {reportData && <Bar data={reportData} options={options} />}
        </div>
    );
};
*/}
